import tulkojumi from 'utils/tulkojumi';

const i18n = (teksti) => ({
  previousMonth: tulkojumi(teksti, 'ieprieksejais_menesis'),
  nextMonth: tulkojumi(teksti, 'nakamais_menesis'),
  months: [
    tulkojumi(teksti, 'janvaris'),
    tulkojumi(teksti, 'februaris'),
    tulkojumi(teksti, 'marts'),
    tulkojumi(teksti, 'aprilis'),
    tulkojumi(teksti, 'maijs'),
    tulkojumi(teksti, 'junijs'),
    tulkojumi(teksti, 'julijs'),
    tulkojumi(teksti, 'augusts'),
    tulkojumi(teksti, 'septembris'),
    tulkojumi(teksti, 'oktobris'),
    tulkojumi(teksti, 'novembris'),
    tulkojumi(teksti, 'decembris'),
  ],
  weekdays: [
    tulkojumi(teksti, 'svetdiena'),
    tulkojumi(teksti, 'pirmdiena'),
    tulkojumi(teksti, 'otrdiena'),
    tulkojumi(teksti, 'tresdiena'),
    tulkojumi(teksti, 'ceturtdiena'),
    tulkojumi(teksti, 'piektdiena'),
    tulkojumi(teksti, 'sestdiena'),
  ],
  weekdaysShort: [
    tulkojumi(teksti, 'sv'),
    tulkojumi(teksti, 'pr'),
    tulkojumi(teksti, 'ot'),
    tulkojumi(teksti, 'tr'),
    tulkojumi(teksti, 'ce'),
    tulkojumi(teksti, 'pk'),
    tulkojumi(teksti, 'se'),
  ],
});

export default i18n;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/DateInput/i18n.js